module.exports = __webpack_public_path__ + "img/RottenTomatoes_logo.ec77f3d7.png";